import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-report-estamp',
    templateUrl: './report-estamp.component.html',
    styleUrls: ['./report-estamp.component.scss'],
    standalone: false
})
export class ReportEstampComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
